export default "__VITE_ASSET__CefL5TQT__"